import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { TOKENS, SIZES } from "../consts";
import { rtlSpacing } from "../../utils/rtl";

var getButtonLinkSpacing = function getButtonLinkSpacing() {
  return function (_ref) {
    var _TOKENS$paddingButton, _TOKENS$paddingButton2, _TOKENS$paddingButton3, _TOKENS$paddingButton4, _tokens;

    var theme = _ref.theme,
        onlyIcon = _ref.onlyIcon,
        iconRight = _ref.iconRight,
        iconLeft = _ref.iconLeft,
        size = _ref.size;
    if (onlyIcon) return rtlSpacing(theme.orbit.paddingButtonWithoutText)({
      theme: theme
    });
    var tokens = (_tokens = {}, _defineProperty(_tokens, TOKENS.paddingButton, (_TOKENS$paddingButton = {}, _defineProperty(_TOKENS$paddingButton, SIZES.LARGE, theme.orbit.paddingButtonLarge), _defineProperty(_TOKENS$paddingButton, SIZES.NORMAL, theme.orbit.paddingButtonNormal), _defineProperty(_TOKENS$paddingButton, SIZES.SMALL, theme.orbit.paddingButtonSmall), _TOKENS$paddingButton)), _defineProperty(_tokens, TOKENS.paddingButtonWithIcons, (_TOKENS$paddingButton2 = {}, _defineProperty(_TOKENS$paddingButton2, SIZES.LARGE, theme.orbit.paddingButtonLargeWithIcons), _defineProperty(_TOKENS$paddingButton2, SIZES.NORMAL, theme.orbit.paddingButtonNormalWithIcons), _defineProperty(_TOKENS$paddingButton2, SIZES.SMALL, theme.orbit.paddingButtonSmallWithIcons), _TOKENS$paddingButton2)), _defineProperty(_tokens, TOKENS.paddingButtonWithLeftIcon, (_TOKENS$paddingButton3 = {}, _defineProperty(_TOKENS$paddingButton3, SIZES.LARGE, theme.orbit.paddingButtonLargeWithLeftIcon), _defineProperty(_TOKENS$paddingButton3, SIZES.NORMAL, theme.orbit.paddingButtonNormalWithLeftIcon), _defineProperty(_TOKENS$paddingButton3, SIZES.SMALL, theme.orbit.paddingButtonSmallWithLeftIcon), _TOKENS$paddingButton3)), _defineProperty(_tokens, TOKENS.paddingButtonWithRightIcon, (_TOKENS$paddingButton4 = {}, _defineProperty(_TOKENS$paddingButton4, SIZES.LARGE, theme.orbit.paddingButtonLargeWithRightIcon), _defineProperty(_TOKENS$paddingButton4, SIZES.NORMAL, theme.orbit.paddingButtonNormalWithRightIcon), _defineProperty(_TOKENS$paddingButton4, SIZES.SMALL, theme.orbit.paddingButtonSmallWithRightIcon), _TOKENS$paddingButton4)), _tokens);

    if (iconLeft && iconRight) {
      return rtlSpacing(tokens[TOKENS.paddingButtonWithIcons][size])({
        theme: theme
      });
    }

    if (iconLeft && !iconRight) {
      return rtlSpacing(tokens[TOKENS.paddingButtonWithLeftIcon][size])({
        theme: theme
      });
    }

    if (!iconLeft && iconRight) {
      return rtlSpacing(tokens[TOKENS.paddingButtonWithRightIcon][size])({
        theme: theme
      });
    }

    return rtlSpacing(tokens[TOKENS.paddingButton][size])({
      theme: theme
    });
  };
};

export default getButtonLinkSpacing;